"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var d3Scale = require("d3-scale");
var d3Array = require("d3-array");
var d3Axis = require("d3-axis");
var d3 = __assign({}, d3Scale, d3Array, d3Axis);
var monitoring_1 = require("../../services/monitoring");
var classNames = require("classnames");
var ScatterChart = /** @class */ (function (_super) {
    __extends(ScatterChart, _super);
    function ScatterChart(props) {
        var _this = _super.call(this, props) || this;
        _this.calculateControlledToolTipState = function (dataIndex) {
            // Recalculating the {x,y} position for a dataIndex in order to show the toolTip
            if (dataIndex > -1) {
                var _a = _this.props, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, width = _a.width, height = _a.height, toolTipElement = _a.toolTipElement;
                var _b = _this.state, xScale = _b.xScale, yScale = _b.yScale;
                var dataItem = _this.props.data[dataIndex];
                var cx = xScale(dataItem[xAxisKey]);
                var cy = yScale(dataItem[yAxisKey]);
                // Conditionally move the tooltip away from the chart edges
                var _c = _this.state, toolTipWidth = _c.toolTipWidth, toolTipHeight = _c.toolTipHeight;
                var xThreshold = toolTipWidth ? toolTipWidth : 25;
                var yThreshold = toolTipHeight ? toolTipHeight : 25;
                if (cx > width - xThreshold) {
                    cx = cx - xThreshold + 25;
                }
                if (cy > height - yThreshold) {
                    cy = cy - yThreshold - 25;
                }
                return {
                    x: cx,
                    y: cy
                };
            }
            else {
                return { x: null, y: null };
            }
        };
        _this.svgRefCallback = function (node) {
            _this.svgEl = node;
        };
        _this.onCircleMouseOver = function (e) {
            // Get the index from the circle and pass it to the callback
            var currentMouseOverDataIndex = parseInt(e.target.getAttribute('data-index'), 10);
            _this.props.dataIndexHoveredCallback(currentMouseOverDataIndex);
        };
        _this.onCircleMouseOut = function (e) {
            // Get the index from the circle and pass it to the callback
            var currentMouseOverDataIndex = parseInt(e.target.getAttribute('data-index'), 10);
            _this.props.dataIndexEndedHoverCallback(currentMouseOverDataIndex);
        };
        _this.circleElements = function () {
            // This method returns all <circle/> elements built from the data prop
            var self = _this;
            var _a = _this.props, data = _a.data, xAxisKey = _a.xAxisKey, yAxisKey = _a.yAxisKey, hoveredDataIndex = _a.hoveredDataIndex;
            var _b = _this.state, xScale = _b.xScale, yScale = _b.yScale;
            var circleElements = data.map(function (item, index) {
                // Default circle opacity
                var circleOpactiy = 0.6;
                // Default circle opacity when one it hovered
                if (hoveredDataIndex > -1) {
                    circleOpactiy = 0.3;
                }
                // Hovered circle opacity
                if (index === hoveredDataIndex) {
                    circleOpactiy = 1.0;
                }
                var circleProps = {
                    cx: xScale(item[xAxisKey]),
                    cy: yScale(item[yAxisKey]),
                    r: 7,
                    className: 'dot',
                    key: index,
                    'data-index': index,
                    fill: '#FFB419',
                    opacity: circleOpactiy,
                    stroke: 'white',
                    strokeWidth: '1',
                    onMouseOver: self.onCircleMouseOver,
                    onMouseOut: self.onCircleMouseOut
                };
                return React.createElement("circle", __assign({}, circleProps, { key: circleProps.key }));
            });
            return React.createElement("g", null, circleElements);
        };
        _this.toolTipElement = function () {
            return _this.props.toolTipElement || null;
        };
        _this.chartElements = function () {
            // This method returns the background rectangles based on state.quadrantsIntersection
            // It also returns each axis line, arrow, and text name
            var rectColor = _this.props.rectColor || '#B5E9F5';
            var rectOpacity = _this.props.rectOpacity || 0.3;
            var _a = _this.props, padding = _a.padding, width = _a.width, height = _a.height;
            var _b = _this.props, xAxisKey = _b.xAxisKey, yAxisKey = _b.yAxisKey, xAxisName = _b.xAxisName, yAxisName = _b.yAxisName;
            var _c = _this.state, yScale = _c.yScale, xScale = _c.xScale;
            // Calculate axis offset based on axis name length
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            ctx.font = '11px system-ui';
            var axisLengthCutBuffer = 20;
            var xAxisLengthCut = ctx.measureText(xAxisName.toUpperCase()).width + axisLengthCutBuffer;
            var yAxisLengthCut = ctx.measureText(yAxisName.toUpperCase()).width + axisLengthCutBuffer;
            // Build each axis path
            var arrowHeight = 12;
            var arrowWidth = 8;
            var yAxisArryPath = 'M 0,' +
                (yAxisLengthCut - 2) +
                ' ' +
                arrowWidth / 2 +
                ',' +
                (yAxisLengthCut + arrowHeight) +
                ' ' +
                -arrowWidth / 2 +
                ',' +
                (yAxisLengthCut + arrowHeight) +
                ' z';
            var xAxisArryPath = 'M ' +
                (width - xAxisLengthCut) + // X:  right
                ',' +
                height + // Y: bottom
                ' ' +
                (width - xAxisLengthCut - arrowHeight) + // X: arrowheight less right
                ',' +
                (height + arrowWidth / 2) + // Y: arrowWidth/2 past the bottom
                ' ' +
                (width - xAxisLengthCut - arrowHeight) + // X: arrowheight less right
                ',' +
                (height - arrowWidth / 2) + // Y: arrowWidth/2 above the bottom
                ' z';
            var axisColor = '#EEEEEE';
            var innerHeight = height - padding >= 0 ? height - padding : height;
            return (React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("rect", { id: "full-rect", opacity: rectOpacity, fill: rectColor, width: width, x: padding, height: innerHeight }),
                    React.createElement("rect", { id: "top-rect", opacity: rectOpacity, fill: rectColor, width: width, x: padding, height: _this.state.quadrantsIntersection.y }),
                    React.createElement("rect", { id: "right-rect", opacity: rectOpacity, fill: rectColor, x: _this.state.quadrantsIntersection.x, width: width - _this.state.quadrantsIntersection.x, height: innerHeight })),
                React.createElement("g", null,
                    React.createElement("path", { d: yAxisArryPath, fill: axisColor, className: "axis-arrow" }),
                    React.createElement("path", { d: xAxisArryPath, fill: axisColor, className: "axis-arrow" }),
                    React.createElement("line", { id: "yAxis", stroke: axisColor, y2: height, x1: "0", x2: "0", y1: yAxisLengthCut, strokeWidth: "1" }),
                    React.createElement("line", { id: "xAxis", stroke: axisColor, y2: height, x1: "0.0", x2: width - xAxisLengthCut, y1: height, strokeWidth: "1" }),
                    React.createElement("text", { className: "scatter-chart__axis-title", x: -yAxisLengthCut + 10, y: "4", fill: '#9B9B9B', fontSize: "11", transform: "rotate(270)" }, yAxisName),
                    React.createElement("text", { className: "scatter-chart__axis-title", x: width - xAxisLengthCut + 10, y: height + 3, fill: '#9B9B9B', fontSize: "11" }, xAxisName),
                    _this.props.autoScale ? null : (React.createElement("text", { className: "scatter-chart-axis-zero", x: padding + 2, y: height - padding + 10 }, "0")))));
        };
        _this.toolTipRef = function (element) {
            if (element) {
                if (_this.state.toolTipWidth === undefined ||
                    _this.state.toolTipWidth < element.offsetWidth) {
                    _this.setState({
                        toolTipWidth: element.offsetWidth
                    });
                }
                if (_this.state.toolTipHeight === undefined ||
                    _this.state.toolTipHeight < element.offsetHeight) {
                    _this.setState({
                        toolTipHeight: element.offsetHeight
                    });
                }
            }
        };
        var scales = _this.calculateD3Scales(props);
        _this.state = {
            width: 0,
            tooltipPosition: { x: null, y: null },
            yScale: scales.yScale,
            xScale: scales.xScale,
            quadrantsIntersection: _this.calculateQuadrants(props, scales.yScale, scales.xScale)
        };
        return _this;
    }
    ScatterChart.prototype.componentDidMount = function () {
        monitoring_1.default('scatterChart');
    };
    ScatterChart.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return JSON.stringify(nextProps) !== JSON.stringify(this.props);
    };
    ScatterChart.prototype.calculateQuadrants = function (props, yScale, xScale) {
        // Default max section sizes
        var quadrantsIntersection = { x: 0, y: props.height - props.padding };
        // Override with passed in data indexes
        if (props.yAxisQuadrantDataIndex && props.yAxisQuadrantDataIndex > -1) {
            var yAxisQuadrantDataPoint = props.data[props.yAxisQuadrantDataIndex];
            var yMin = yAxisQuadrantDataPoint[props.yAxisKey];
            quadrantsIntersection.y = yScale(yMin);
        }
        else {
            // Set quadrant y to chart height to overlay fully to match coloring
            quadrantsIntersection.y = props.height - props.padding;
        }
        if (props.xAxisQuadrantDataIndex && props.xAxisQuadrantDataIndex > -1) {
            var xAxisQuadrantDataPoint = props.data[props.xAxisQuadrantDataIndex];
            var xMin = xAxisQuadrantDataPoint[props.xAxisKey];
            quadrantsIntersection.x = xScale(xMin);
        }
        else {
            // Set quadrant x to chart left overlay fully to match coloring
            quadrantsIntersection.x = props.padding;
        }
        return quadrantsIntersection;
    };
    ScatterChart.prototype.calculateD3Scales = function (props) {
        // Calculates D3Scales based on the data ranges for each axis
        var xMax = function (data) { return d3.max(data, function (d) { return d[props.xAxisKey]; }); };
        var yMax = function (data) { return d3.max(data, function (d) { return d[props.yAxisKey]; }); };
        var xMin = function (data) {
            if (props.autoScale) {
                return d3.min(data, function (d) { return d[props.xAxisKey]; });
            }
            else {
                return 0;
            }
        };
        var yMin = function (data) {
            if (props.autoScale) {
                return d3.min(data, function (d) { return d[props.yAxisKey]; });
            }
            else {
                return 0;
            }
        };
        var xMinValue = xMin(props.data);
        var yMinValue = yMin(props.data);
        var xMaxValue = xMax(props.data);
        var yMaxValue = yMax(props.data);
        // Lower the x and y min values by 3 percent of the range to give some space when autoscaling
        var percentagePadding = 3;
        if (props.autoScale) {
            yMinValue = yMinValue - (yMaxValue - yMinValue) / 100 * percentagePadding;
            xMinValue = xMinValue - (xMaxValue - xMinValue) / 100 * percentagePadding;
            // Ensure the xMin and yMin values aren't below zero
            if (yMinValue < 0) {
                yMinValue = 0;
            }
            if (xMinValue < 0) {
                xMinValue = 0;
            }
        }
        var xScale = function (passedProps) {
            return d3
                .scaleLinear()
                .domain([xMinValue, xMaxValue])
                .range([
                passedProps.padding,
                passedProps.width - passedProps.padding * 2
            ]);
        };
        var yScale = function (passedProps) {
            return d3
                .scaleLinear()
                .domain([yMinValue, yMaxValue])
                .range([passedProps.height - passedProps.padding, passedProps.padding]);
        };
        var scales = { xScale: xScale(props), yScale: yScale(props) };
        return scales;
    };
    ScatterChart.prototype.componentWillReceiveProps = function (newProps) {
        var scales = this.calculateD3Scales(newProps);
        var newState = __assign({}, this.state, {
            xScale: scales.xScale,
            yScale: scales.yScale,
            quadrantsIntersection: this.calculateQuadrants(newProps, scales.yScale, scales.xScale)
        });
        // If hovered data index changes, recalculate tooltip position
        if (newProps.hoveredDataIndex > -1 &&
            newProps.hoveredDataIndex !== this.props.hoveredDataIndex) {
            newState = __assign({}, newState, { tooltipPosition: __assign({}, this.calculateControlledToolTipState(newProps.hoveredDataIndex)) });
        }
        this.setState(newState);
    };
    ScatterChart.prototype.render = function () {
        var _this = this;
        var _a = this.props, width = _a.width, height = _a.height, padding = _a.padding, className = _a.className, style = _a.style;
        var tooltipPosition = this.state.tooltipPosition;
        var classes = classNames('scatter-chart', className);
        var styles = __assign({ width: '100%', position: 'relative' }, style);
        var innerWidth = width, innerHeight = height;
        if (innerWidth - padding >= 0) {
            innerWidth = innerWidth - padding;
        }
        if (innerHeight - padding >= 0) {
            innerHeight = innerHeight - padding;
        }
        return (React.createElement("div", { className: classes, style: styles, ref: this.svgRefCallback },
            React.createElement("svg", { width: width, height: height },
                React.createElement("svg", { width: innerWidth, height: innerHeight, x: padding / 2, y: -padding / 2, style: { overflow: 'visible' } },
                    this.chartElements(),
                    this.circleElements())),
            React.createElement("div", { ref: function (element) { return _this.toolTipRef(element); }, style: {
                    position: 'absolute',
                    left: tooltipPosition.x,
                    top: tooltipPosition.y
                } }, this.toolTipElement())));
    };
    ScatterChart.defaultProps = {
        padding: 20
    };
    return ScatterChart;
}(React.Component));
exports.default = ScatterChart;
//# sourceMappingURL=ScatterChart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/ScatterChart/ScatterChart.js
// module id = 285
// module chunks = 0